import { render } from "./QueryByFeature.vue?vue&type=template&id=40d2e6ab&ts=true"
import script from "./QueryByFeature.vue?vue&type=script&lang=ts"
export * from "./QueryByFeature.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__